<lb-paneled-viewer [items]="history" [(selected)]="selected">
    <ng-template pTemplate="selector">
        <p-table [value]="allItems">
            <ng-template pTemplate="body" let-cpxObj>
                <tr [ngClass]="{'p-highlight': cpxObj.value === selected}" class="clickable" (click)="selected = cpxObj.value">
                    <td>
                        <ng-container *ngIf="isPublished(cpxObj) || isPublished(cpxObj)">
                            <p-tag [value]="isDraft(cpxObj) ? 'Draft' : 'Published'"></p-tag>
                            <br>
                        </ng-container>
                        <div>
                            {{getName(cpxObj.value)}}
                        </div>
                        <div>
                            {{cpxObj.display}}
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-template>
    <ng-template pTemplate="empty">
        <div class="p-text-center">
            <label>{{noSelectionText}}</label>
        </div>
    </ng-template>
    <ng-template pTemplate="content" let-cpxObj>
        <div class="p-grid">
            <div class="p-col-10">
                <h4>{{getName(cpxObj)}}</h4>
                <span *ngIf="cpxObj.published">Published {{formatDate(cpxObj.published)}}</span>
            </div>
            <div class="p-col-2 p-d-flex p-flex-column p-ai-center p-jc-center p-fluid" style="margin-top: 10px;">
                <button *ngIf="cpxObj.isDraft && publishEnabled" pButton label="Publish" icon="pi pi-check" (click)="publish(cpxObj, $event)"></button>
                <button *ngIf="editEnabled" pButton label="Edit" icon="pi pi-pencil" (click)="edit(cpxObj)"></button>
                <button *ngIf="deleteEnabled && !cpxObj.activeRevision" pButton label="Delete" icon="pi pi-trash" class="p-button-danger p-mt-2" (click)="delete(cpxObj, $event)"></button>
            </div>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
            <div class="p-col-12">
                <div>Created: {{formatDate(cpxObj.created)}}</div>
                <div>Created by: {{getCreatedByName(cpxObj)}}</div>
                <div>ID: {{cpxObj.complexObject.id}}</div>
                <div>Revision: {{cpxObj.id}}</div>
            </div>
        </div>
        <ng-container *ngIf="currentComment">
            <p-divider></p-divider>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <label class="p-mb-1 p-d-block" *ngIf="cpxObj.versionNote && !inplaceEditor.active">Comment</label>
                    <lb-inplace-editor #inplaceEditor (onActivate)="currentComment.saveState()" (onAccept)="saveComment()" (onReject)="currentComment.rollback()" acceptLabel="Save Comment">
                        <ng-container display>
                            <div class="whitespace-pre p-d-inline">
                                <span>{{cpxObj.versionNote ? cpxObj.versionNote : noCommentMessage}}</span>
                            </div>
                        </ng-container>
                        <ng-container content>
                            <textarea pInputTextarea placeholder="Comment" [rows]="5" [(ngModel)]="currentComment.value" style="resize: none"></textarea>
                        </ng-container>
                    </lb-inplace-editor>
                </div>
            </div>
        </ng-container>
    </ng-template>
</lb-paneled-viewer>
<p-confirmPopup [key]="key"></p-confirmPopup>